import { render } from "./SectionInfoByRoute.vue?vue&type=template&id=603ef827"
import script from "./SectionInfoByRoute.vue?vue&type=script&lang=js"
export * from "./SectionInfoByRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__